import {
  type ErrorType,
  useApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate,
  useApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate,
  useUploadFile,
} from 'api';
import { useCallback } from 'react';

import { type UploadGenericDocumentProps } from '../../../document/types';

export const useUploadAndCreateDocument = () => {
  const { mutateAsync: createDocument } =
    useApiTradeV1BuyerMaterialSpecificationsDocumentsUploadCreate<ErrorType<Error>>();
  const { mutateAsync: generatePreSignedURL } =
    useApiTradeV1BuyerMaterialSpecificationsDocumentsPreSignedUrlCreate<ErrorType<Error>>();

  const { mutateAsync: uploadFile } = useUploadFile();

  return useCallback(
    async (buyerMaterialSpecificationId: number, document: UploadGenericDocumentProps) => {
      const { upload_url, file_path } = await generatePreSignedURL({
        buyerMaterialSpecificationId,
        data: { content_type: document.file.type },
      });

      await uploadFile({
        file: document.file,
        headers: { 'content-type': document.file.type },
        url: upload_url,
      });

      await createDocument({
        buyerMaterialSpecificationId,
        data: { file_path },
      });
    },
    [generatePreSignedURL, createDocument, uploadFile]
  );
};
